// Import Packages
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Box, TextField } from '@material-ui/core';

// Import pages
import { TextInput } from '../TextInput/NewTextInput';

// Import CSS
import '../CredentialPicker/CredentialPicker.css';


function TabPanel({ children, value, index }) {
    return (<div>{value === index && (<Box>{children}</Box>)}</div>);
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function CustomDateTab({ action, inputName, variables, setOpenVariable, variableRender, setField, type, displayName, onChange, isRequired }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION.';
    const [value, setValue] = useState('');
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (action.fields) {
            if (!action.fields[inputName]) {
                action.fields[inputName] = { type, isRequired: isRequired, value: '', tab: 0 };
            } else if (action.fields[inputName]?.tab !== undefined) {
                setTab(action.fields[inputName].tab);
            } else {
                action.fields[inputName].tab = 0;
                setTab(0);
            }
            setValue(action.fields[inputName].value);
        } else if (action[inputName]) {
            if (action[inputName].tab === undefined) {
                action[inputName].tab = 0;
                setTab(0);
            } else {
                setTab(action[inputName].tab);
            }
            setValue(action[inputName].value)
        } else {
            action[inputName] = { type, isRequired: isRequired, value: '', tab: 0 }
        }
    }, [])

    const ChangeTab = (newTab) => {
        // if you select the tab, the value will be assigned if it is inside
        if (newTab === 0) {
            onChange("");
            setValue("");
        }

        // change new tab
        setTab(newTab);
        if (action.fields && action.fields[inputName]) {
            action.fields[inputName].tab = newTab;
        } else if (action[inputName]) {
            action[inputName].tab = newTab;
        }
    };

    const handleChange = (v) => {
        setValue(v);
        onChange(v);
    };

    return (
        <div>
            <div className="condition-tabs">
                <button
                    className={`f-s-11 ${tab === 0 ? 'condition-active' : ''}`}
                    onClick={() => ChangeTab(0)}>
                    {t(label + "SELECT")}
                </button>
                <button
                    className={`f-s-11 ${tab === 1 ? 'condition-active' : ''}`}
                    onClick={() => ChangeTab(1)}>
                    {t(label + "TEXT")}
                </button>
            </div>

            <TabPanel value={tab} index={0} >
                <TextField value={value}
                    fullWidth type={type === 'datetime' ? 'datetime-local' : type}
                    onChange={(e) => handleChange(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                />
            </TabPanel>
            <TabPanel value={tab} index={1} >
                <TextInput
                    inputName={inputName}
                    action={action}
                    setField={setField}
                    variableRender={variableRender}
                    variables={variables}
                    include={[type]}
                    multiline={type === "object"}
                    setOpenVariable={setOpenVariable}
                    isRequired={isRequired}
                    fieldType={"string"}
                    displayName={displayName}
                    hideRequired={true}
                />
            </TabPanel>
        </div>
    );
}

export default CustomDateTab
